<template>
    <div>

            <div class="extra-field-list-container">
                <ul :class="{ 'numerous-list' : isNumerousList }">
                    <template v-for="extraField in extraFields" >
                        <captive-forms-modal-extra-fields-item :item="extraField"
                                          :key="extraField.id"
                                          :captiveLoginTypeId="captiveLoginTypeId"
                                          @edited="loadExtraFields"
                                          @deleted="loadExtraFields"/>
                    </template>
                </ul>
            </div>

            <div class="extra-fields-form">
                <captive-forms-modal-extra-fields-form @submit="loadExtraFields"/>
            </div>
            
    </div>

</template>

<script>
import CaptiveFormsModalExtraFieldsForm from "./form/CaptiveFormsModalExtraFieldsForm.vue"
import CaptiveFormsModalExtraFieldsItem from "./item/CaptiveFormsModalExtraFieldsItem.vue"
import EventBus from "@packages/event-bus";

export default {
    components: {
        CaptiveFormsModalExtraFieldsForm,
        CaptiveFormsModalExtraFieldsItem
    },

    props: {
        showing: {
            type: Boolean,
            default: false,
        },
        captiveLoginTypeId: {
            type: String
        }
    },

    data() {
        return {
            form: {
                name: "",
            },
            extraFieldsLoaded: false,
            extraFields: [],
            extraField: undefined,
            showDeleteConfirmModal: false,
            extraFieldToDelete: undefined,
            showingEditForm: false,
        };
    },

    computed: {
        establishmentId() {
            return this.$store.state.users.user.accountId
        },
        isNumerousList() {
            return this.extraFields.length > 6
        }
    },

    methods: {
        async loadExtraFields() {
            try {
                this.extraFieldsLoaded = false;

                const list = await this.$api.core.extraField.extraFieldsListByCaptiveLogin(this.captiveLoginTypeId);

                this.extraFields = this.moveLockedObjectToFirst(list);

                this.extraFieldsLoaded = true;
            } catch (error) {
                console.log(error);
            }
        },
        async deleteNode() {
            try {
                await this.$api.core.extraField.delete({ id: this.extraFieldToDelete });

                this.removeNode({ id: this.userToDelete });

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t('message.successMessages.message.userDeleted'),
                    timeout: 2000,
                });

                this.showDeleteConfirmModal = false;
            } catch (error) {
                console.log(error);
            }
        },
        emitShowing(value) {
            this.$emit("input", value);
        },
        showDeleteModal(extraField) {
            this.extraFieldToDelete = extraField.id;
            this.showDeleteConfirmModal = true;
        },
        emitEdited() {
            this.$emit("edited");
        },
        openEdit(extraField) {
            this.extraField = extraField;
            this.showingEditForm = true;
        },
        resetShowingEdit() {
            this.showingEditForm = false;
        },
        onSubmit() {
            this.resetShowingEdit();
            this.emitEdited();
        },
        moveLockedObjectToFirst(list) {
            for (let i = 0; i < list.length; i++) {
                if (list[i].isLocked === true) {
                    const lockedField = list.splice(i, 1)[0];
                    list.unshift(lockedField);
                    break; 
                }
            }
            return list
        }

    },

    async created() {
        await this.loadExtraFields();
    },

};
</script>

<style lang="scss" >
@import "~@variables";

#extraFieldModal .modal-body-content {
     margin: 0 auto;

}

.extra-field-list-container {
    margin-bottom: 30px;
    max-height: 350px;
    overflow-y: scroll;

    ul {
        display: grid;
        list-style: none;
       

        li {
            margin-bottom: 15px;
        }

    }

    .numerous-list {
        display: grid;
        column-gap: 50px;
        grid-template-columns: auto auto;
    }

    .extra-field-wrapper {
        display: flex;
        gap: 20px;

        .flex {
            display: flex;
            gap: 6px;
            align-items: center;

            label {
                font-size: 12px;
            }
        }
    }
}

.extra-fields-form {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}


.extra-fields-modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
        padding-left: 50px;
        padding-right: 50px;
    }
}



</style>
